'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleAnalytics = exports.getExperimentBranch = exports.dimensions = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _localStorage = require('redux/saga/helpers/local-storage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * ATTENTION!
 *
 * If you just want to track some events, please use `ga` from `helpers/multitrack`
 */

var GA_INIT = '(function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\n(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\nm=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n})(window,document,\'script\',\'//www.google-analytics.com/analytics.js\',\'ga\');';

var dimensions = exports.dimensions = {
  EXPERIMENT_BRANCH: 'dimension4',
  USER_TYPE: 'dimension8',
  EXPERIMENT: 'dimension9',
  PROMOTION: 'dimension16',
  USER_ID: 'dimension17'
};

var getExperimentBranch = exports.getExperimentBranch = function getExperimentBranch(testId, variantId) {
  return testId ? 'test_' + testId + '_variant_' + variantId : null;
};

// This lives outside of the component so it can be used in places that are
// not in the component heirarchy (such as sagas).
var safeGa = function ga() {
  var gaFn = (__CLIENT__ || __TEST__) && typeof window.ga !== 'undefined' && window.ga;
  if (gaFn !== 'undefined' && gaFn) {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (__CLIENT__ && (0, _localStorage.readLocalStorage)('trackingDebug')) {
      var _console;

      (_console = console).info.apply(_console, ['Tracking ga'].concat(args)); // eslint-disable-line no-console
    }
    gaFn.apply(undefined, args);
  }
};

var GoogleAnalytics = exports.GoogleAnalytics = function (_React$Component) {
  (0, _inherits3.default)(GoogleAnalytics, _React$Component);

  function GoogleAnalytics() {
    (0, _classCallCheck3.default)(this, GoogleAnalytics);
    return (0, _possibleConstructorReturn3.default)(this, (GoogleAnalytics.__proto__ || (0, _getPrototypeOf2.default)(GoogleAnalytics)).apply(this, arguments));
  }

  (0, _createClass3.default)(GoogleAnalytics, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var cookies = _cookie2.default.parse(document.cookie);
      safeGa('set', dimensions.USER_TYPE, cookies.cpUserType || 'prospect');
      safeGa('send', 'pageview');
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          currentPath = _props.currentPath,
          userId = _props.userId;

      // Track a GA page view if the URL changes

      if (currentPath !== prevProps.currentPath) {
        safeGa('send', 'pageview');
      }
      if (!prevProps.userId && userId) {
        safeGa('set', dimensions.USER_ID, String(userId));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          accountKey = _props2.accountKey,
          cookieDomain = _props2.cookieDomain,
          userId = _props2.userId;


      var initLines = [];

      initLines.push('ga(\'create\', \'' + accountKey + '\', { cookieDomain: \'' + cookieDomain + '\' });');

      // Optimizely Universal Analytics Integration
      initLines.push('window.optimizely = window.optimizely || [];');
      initLines.push('window.optimizely.push("activateUniversalAnalytics");');

      if (userId) {
        initLines.push('ga(\'set\', \'userId\', \'' + userId + '\');');
        initLines.push('ga(\'set\', \'' + dimensions.USER_ID + '\', \'' + userId + '\');');
      }

      return _react2.default.createElement('script', {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: { __html: (GA_INIT + '\n' + initLines.join('\n')).replace(/\n/g, '') }
      });
    }
  }]);
  return GoogleAnalytics;
}(_react2.default.Component);

GoogleAnalytics.sendPageView = function (path, customDimensions) {
  safeGa('send', (0, _extends3.default)({
    page: path,
    hitType: 'pageview'
  }, customDimensions));
};

GoogleAnalytics.propTypes = {
  currentPath: _propTypes2.default.string.isRequired,
  accountKey: _propTypes2.default.string.isRequired,
  cookieDomain: _propTypes2.default.string.isRequired,
  userId: _propTypes2.default.number
};